import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { ScorecardsV2HeroListComponent } from './scorecards-v2-hero-list/scorecards-v2-hero-list.component';
import { ScorecardsV2BadgesComponent } from './scorecards-v2-badges/scorecards-v2-badges.component';
import { ScorecardsV2DescriptionComponent } from './scorecards-v2-description/scorecards-v2-description.component';
import { ScorecardsV2CardsComponent } from './scorecards-v2-cards/scorecards-v2-cards.component';
import { ScorecardsV2FeaturedComponent } from './scorecards-v2-featured/scorecards-v2-featured.component';
import { ScorecardsV2ActionComponent } from './scorecards-v2-action/scorecards-v2-action.component';
import { ScorecardV2MilestoneValuePipe } from './scorecards-v2-milestone-value.pipe';

@NgModule({
  declarations: [
    ScorecardsV2HeroListComponent,
    ScorecardsV2BadgesComponent,
    ScorecardsV2DescriptionComponent,
    ScorecardsV2CardsComponent,
    ScorecardsV2FeaturedComponent,
    ScorecardsV2ActionComponent,
    ScorecardV2MilestoneValuePipe,
  ],
  imports: [CommonModule, RouterModule, CarouselModule, FGBSharedModule, PipesModule, DirectivesModule],
  exports: [
    ScorecardsV2HeroListComponent,
    ScorecardsV2BadgesComponent,
    ScorecardsV2DescriptionComponent,
    ScorecardsV2CardsComponent,
    ScorecardsV2FeaturedComponent,
    ScorecardsV2ActionComponent,
    ScorecardV2MilestoneValuePipe,
  ],
})
export class ScorecardsV2Module {}
